import { render, staticRenderFns } from "./ProjectProfileImage.vue?vue&type=template&id=f16787a2&scoped=true&"
import script from "./ProjectProfileImage.vue?vue&type=script&lang=js&"
export * from "./ProjectProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProfileImage.vue?vue&type=style&index=0&id=f16787a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16787a2",
  null
  
)

export default component.exports